export default "__VITE_ASSET__BEZKcKuq__"